import Icon from 'veui/components/Icon'
import { IconUserIntersection } from 'dls-icons-vue'

Icon.register('user-intersection', IconUserIntersection)
